import { motion } from 'framer-motion';
import { Award, Calendar, Building2 } from 'lucide-react';
import { honors } from '../data/honors';

const Honors = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, scale: 0.9, y: 20 },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        duration: 0.5,
      },
    },
  };

  return (
    <section
      id="honors"
      className="bg-gradient-to-b from-gray-900 to-black px-4 py-20 sm:px-6 lg:px-8"
    >
      <div className="container mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-16 text-center"
        >
          <h2 className="mb-4 bg-gradient-to-r from-white to-gray-400 bg-clip-text text-4xl font-bold text-transparent sm:text-5xl">
            Honors & Awards
          </h2>
          <div className="mx-auto h-1 w-24 bg-gradient-to-r from-blue-500 to-red-500"></div>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 gap-6 md:grid-cols-2"
        >
          {honors.map(honor => (
            <motion.div
              key={honor.id}
              variants={itemVariants}
              whileHover={{ scale: 1.05, y: -5, rotateY: 5 }}
              className="group rounded-xl border border-white/10 bg-white/5 p-6 backdrop-blur-md transition-all duration-300 hover:bg-white/10"
            >
              <div className="mb-4 flex items-start justify-between">
                <div className="rounded-lg bg-gradient-to-br from-blue-500/20 to-red-500/20 p-3 transition-all group-hover:from-blue-500/30 group-hover:to-red-500/30">
                  <Award className="h-6 w-6 text-blue-400" />
                </div>
                <div className="flex items-center gap-1 text-sm text-gray-400">
                  <Calendar className="h-4 w-4" />
                  <span>{honor.date}</span>
                </div>
              </div>

              <h3 className="mb-2 text-lg font-bold text-white transition-colors group-hover:text-blue-400">
                {honor.title}
              </h3>

              <div className="mb-3 flex items-center gap-2 text-sm text-gray-400">
                <Building2 className="h-4 w-4" />
                <span>{honor.issuer}</span>
              </div>

              <p className="mb-4 text-sm text-gray-300">{honor.description}</p>

              {honor.details && honor.details.length > 0 && (
                <div className="mt-4 space-y-2">
                  <p className="text-xs font-medium text-gray-400">Details:</p>
                  <ul className="space-y-1">
                    {honor.details.map((detail, idx) => (
                      <li key={idx} className="flex items-start gap-2 text-xs text-gray-400">
                        <span className="mt-1 text-blue-500">▸</span>
                        <span>{detail}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Honors;
